import { render, staticRenderFns } from "./DropGuard.vue?vue&type=template&id=7af07312&lang=pug"
import script from "./DropGuard.vue?vue&type=script&lang=js"
export * from "./DropGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports